import { createAction } from "@reduxjs/toolkit";
import {
  WalletActionTypes,
  WalletInfo,
  WalletTransaction,
} from "./walletTypes";
import { WalletInfoDto } from "services/api.services/user/userServiceType";

export const fetchWalletRequest = createAction<{
  userId: string;
  force?: boolean;
}>(WalletActionTypes.FETCH_WALLET_REQUEST);

export const fetchWalletSuccess = createAction<{
  info: WalletInfo;
  transactions: WalletTransaction[];
}>(WalletActionTypes.FETCH_WALLET_SUCCESS);

export const fetchWalletFailure = createAction<string>(
  WalletActionTypes.FETCH_WALLET_FAILURE,
);

export const hydrateWalletFromLogin = createAction<{
  userId: string;
  walletInfo: WalletInfoDto | null;
}>(WalletActionTypes.HYDRATE_FROM_LOGIN);

export const clearWallet = createAction(WalletActionTypes.CLEAR_WALLET);

// import { createAction } from "@reduxjs/toolkit";
// import {
//   WalletActionTypes,
//   WalletInfo,
//   WalletTransaction,
// } from "./walletTypes";

// // API trigger: userId + optional forceRefresh
// export const fetchWalletRequest = createAction<{
//   userId: string;
//   force?: boolean;
// }>(WalletActionTypes.FETCH_WALLET_REQUEST);

// export const fetchWalletSuccess = createAction<{
//   info: WalletInfo;
//   transactions: WalletTransaction[];
// }>(WalletActionTypes.FETCH_WALLET_SUCCESS);

// export const fetchWalletFailure = createAction<string>(
//   WalletActionTypes.FETCH_WALLET_FAILURE,
// );

// // login se wallet hydrate
// export const hydrateWalletFromLogin = createAction<{
//   userId: string;
//   walletInfo: {
//     hasWallet: boolean;
//     walletPublicKey: string;
//     walletType: string | null;
//     isKyc: boolean;
//     isMinKyc: boolean;
//     kycState: string | null;
//     activeBalance: number;
//     encWalletToken: string;
//     encWalletTokenIV: string;
//     expiryTime: number;
//   } | null;
// }>(WalletActionTypes.HYDRATE_FROM_LOGIN);

// export const clearWallet = createAction(WalletActionTypes.CLEAR_WALLET);
